<template>
  <div>
<!--    <div>-->
<!--      <el-carousel trigger="hover" height="800px" :interval="12000" style="padding-top: 75px;">-->
<!--        <el-carousel-item v-for="(item, bannarDesc) in imgList" :key="bannarDesc">-->
<!--          <img v-bind:src="api + item.bannarUrl" />-->
<!--        </el-carousel-item>-->
<!--      </el-carousel>-->
<!--    </div>-->
    <div class="lowerbox">
      <div class="mlbox">
        <div><a style="color:#008D40 ">新建建筑工程用胶粘剂</a> 产品世界</div>
        <div class="pctitle">The world of adhesive products for urban and rural construction</div>
      </div>
      <div class="cpb">
        <div class="cpbox1" v-for="(item, index) in listData1" :key="index" @click="openDetails(item, index, 'name1')">
          <div class="cpsimg"><img :src="api + item.icon" class="cpimg" alt=""></div>
          <div class="cpname">
            <div class="titleName">{{ item.menuName }} </div>
            <!--            <div>{{ item.productName }}</div>-->
            <div class="detailbox">查看详情</div>
          </div>
        </div>
      </div>
    </div>
    <div class="lowerbox">
      <div class="mlbox">
        <div><a style="color:#008D40 ">建筑工程维修用胶粘剂</a> 产品世界</div>
        <div class="pctitle">The world of adhesive products for old city renovation</div>
      </div>
      <div class="cpb">
        <div class="cpbox1" v-for="(item, index) in listData2" :key="index" @click="openDetails(item, index, 'name2')">
          <div class="cpsimg"><img :src="api + item.icon" class="cpimg" alt=""></div>
          <div class="cpname">
            <div class="titleName">{{ item.menuName }} </div>
            <!--            <div>{{ item.productName }}</div>-->
            <div class="detailbox">查看详情</div>
          </div>
        </div>
      </div>
    </div>

    <div class="lowerbox" v-for="(item, index) in newsList" :key="index"
    v-if="item.visible==='1' && item.isRefresh === '0' && item.children && item.children.length>0">
      <NewsCenter :rootId="item.menuId" :columnTree="[item]" />
    </div>

    <div class="lowerbox">
      <div class="mlbox">
        <div>企业中心</div>
        <div class="pctitle">ENTERPRISE CENTER</div>
      </div>
      <div class="jsbox" @click="opensl()">
        <!--        <div class="imgbox"></div>
        <div class="introduce">
          <div class="cenbox">湖南神力胶业集团</div>
          <div class="textbox">创建于1989年，专业从事有机高分子化合胶粘剂研发/生产/贸易于一体的企业，主要生产石材胶和其他粘胶剂</div>
          <div class="textbox">
            湖南神力胶业集团创建于1989年11月，是一家专业从事有机高分子化合胶粘剂研发、生产、贸易于一体且具有全部自主知识产权的企业。总部座落在长沙国家生物医药园(浏阳工业园)。紧靠319国道，东距长沙市36公里，离长沙市黄花国际机场20公里。公司占地面积19800平方米，地处长浏、岳汝、昌平、浏大四条高速公路交界处，长、株、潭城际轻轨贯穿全境，交通便利。优美的自然环境、便捷的交通环境、高速发展的人文科技环境，孕育出了这家蓝色、漂亮、齐整的现代化企业。神力荣耀成为世界花炮之都浏阳又一崭新的名片。
          </div>
          <div class="more" @click="opensl()">了解更多</div>
        </div>-->
      </div>
    </div>
    <div class="lowerbox">
      <div class="mlbox">
        <div>董事长寄语</div>
        <div class="pctitle">Chairman message</div>
      </div>
      <div class="dszbox"> </div>
    </div>
    <!-- 致用户一封信 -->

    <div class="flexbox">
      <div class="flexImg"><img src="../../static/img/home1.png" alt=""></div>
      <div class="flexImg"><img src="../../static/img/home2.png" alt=""></div>
      <div class="flexImg"><img src="../../static/img/home3.png" alt=""></div>
    </div>
  </div>
</template>
<script>
import { api, deptId } from '../config'
import NewsCenter from './NewsCenter.vue'
export default {
  name: 'Shouye',
  components: { NewsCenter },
  data() {
    return {
      newsTitle: [],
      oneNewTitle: [],
      newsList: [],
      newsList1: [],
      newsList2: [],
      active_btn: 0,
      activeName: 'first',
      imgList: [],
      listData1: [],
      listData2: [],
      //产品分页
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        type: '',
        gjz: '',
      },
      menuId: '',
      name1: '',
      name2: '',
      api,
    }
  },
  created() {

  },
  mounted() {
    this.lbList()
    this.newList()
    // this.zxSubmit()
  },
  methods: {
    //了解更多跳转
    opensl() {
      console.log(111)
      window.location = '/#/ejml?id=18&name=走进神力';
      document.documentElement.scrollTop = 0;
    },
    //打开文件
    openFile(item) {
      window.open(api + item.target)
    },
    openUrl(item) {
      if (item.menuType == 'D') {
        window.location = '/#/cplist?id=' + item.menuId + '&name=' + encodeURI(item.menuName) + '&menuId=' + item.menuId;
      }
    },
    //跳转产品详情页面
    openDetails(item, index, name) {
      console.log(666, item, index, name);
      if (name == 'name1') {
        name = this.name1
      } else {
        name = this.name2
      }
      let menuId = ''
      if (item.children) {
        menuId = item.children[0].menuId
      } else {
        menuId = item.menuId
      }
      // return
      window.location = "/#/cplist?id=" + this.menuId + '&name=产品世界' + '&index=' + index + '&titName=' + name + '&menuId=' + menuId
      // window.location = "/#/cpdetails?id=" + item.productId + '&name=' + encodeURI(item.productName)
    },
    newsDetails(index, items) {
      console.log('点击', items);
      this.newsList1.forEach(item => {
        if (item.menuName == items.menuName) {
          this.newsTitle = item.children
        }
      })
      this.active_btn = index
    },
    handleClick(tab, event) {
    },
    //新闻列表
    newList() {
      let that = this;
      that.$axios.post(api + '/site/columnList', {
        deptId: deptId
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(function (res) {
        if (res.data.code == '0') {
          if (res.data.data) {
            that.newsList = that.handleTree(res.data.data, 'menuId', 'parentId')
            //   console.log(6666,that.newsList);
            //建筑用胶粘剂产品世界数据
            that.newsList.forEach(item => {
              if (item.menuName == '产品世界') {
                that.listData1 = item.children[0].children
                that.listData2 = item.children[1].children
                that.menuId = item.menuId
                that.name1 = item.children[0].menuName
                that.name2 = item.children[1].menuName
              }
            })
          }
        } else {
          that.$message.error(res.message);
        }
      })
    },

    //二级跳转方法
    menuList(item1, id, item2, index) {
      console.log('跳转信息', item1, item2, index);
      // return
      let that = this;
      that.$axios.post(api + '/site/columnDetail', {
        columnId: id
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(function (res) {
        if (res.data.code == '0') {
          if (item1.menuType === 'D') {
            window.open('/#/cplist?id=' + item2.menuId + '&name=' + encodeURI(item2.menuName) + '&index=' + index + '&menuId=' + item2.menuId)
          } else if (item1.menuType === 'C') {
            // console.log(111111,item1.target)
            if (item1.target != '') {
              window.open(api + item1.target)
            }
            // window.location = '/#/ejml?id=' + item2.menuId + '&name=' + encodeURI(item2.menuName) + '&target=' + item1.target + '&index=' + 0;
            // document.documentElement.scrollTop = 0;
            // window.location.reload();
          } else if (res.data.data.length > 0) {
            if (item1.menuType === 'F' && item1.perms == '') {
              that.$message('暂无数据');
              return
            } else if (item1.menuType === 'M' && item1.children == '') {
              that.$message('暂无数据');
              return
            } else if (item1.menuType === 'M') {
              window.open('/#/ejml?id=' + item2.menuId + '&name=' + encodeURI(item2.menuName) + '&index=' + 0);
              // document.documentElement.scrollTop = 0;
              // window.location.reload();
            } else if (item1.menuType === 'F') {
              window.open('/#/ejml?id=' + item2.menuId + '&name=' + encodeURI(item2.menuName) + '&index=' + 0);
              // document.documentElement.scrollTop = 0;
              // window.location.reload();
            }
          }
        } else {
          that.$message.error(res.message);
        }
      })
    },

    // 轮播图列表
    lbList() {
      let that = this;
      let num = 0
      if (screen.width > 765) {
        num = 1
      } else {
        num = 2
      }
      that.$axios.post(api + '/site/bannarList', {
        deptId: deptId,
        bannarType: num
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(function (res) {
        // console.log('轮播',res)
        if (res.data.code == '0') {
          if (res.data.data) {
            //console.log(res.data.data)
            that.imgList = res.data.data
          }
        } else {
          that.$message.error(res.message);
        }
      })
    },
    //产品列表
    /*zxSubmit() {
      let that = this;
      that.$axios.post(api + '/site/productList', {
        columnId: 133,
        deptId:deptId,
        pageNum: this.queryParams.pageNum,
        pageSize: this.queryParams.pageSize,
        param: this.queryParams.gjz,

      },{
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(function (res) {
        if (res.data.code == '0') {
          if (res.data.data) {
            that.listData = res.data.data.rows
            console.log(22222222123,that.listData);
            that.listData.forEach(item => {
              item.productPhoto = item.productPhoto.split(',')
            })
            that.total = res.data.data.total
          }
        } else {
          that.$message.error(res.message);
        }
      })
    },*/
    //树形转换
    handleTree(data, id, parentId, children) {
      let config = {
        id: id || 'id',
        parentId: parentId || 'parentId',
        childrenList: children || 'children'
      };

      var childrenListMap = {};
      var nodeIds = {};
      var tree = [];

      for (let d of data) {
        let parentId = d[config.parentId];
        if (childrenListMap[parentId] == null) {
          childrenListMap[parentId] = [];
        }
        nodeIds[d[config.id]] = d;
        childrenListMap[parentId].push(d);
      }
      for(let g in nodeIds) {
        let d = nodeIds[g];
        if (d[config.parentId]) {
          nodeIds[g].parentOrderNum = nodeIds[d[config.parentId]].orderNum;
        }
      }
      for (let d of data) {
        let parentId = d[config.parentId];
        if (nodeIds[parentId] == null) {
          tree.push(d);
        }
      }

      for (let t of tree) {
        adaptToChildrenList(t);
      }

      function adaptToChildrenList(o) {
        if (childrenListMap[o[config.id]] !== null) {
          o[config.childrenList] = childrenListMap[o[config.id]];
        }
        if (o[config.childrenList]) {
          for (let c of o[config.childrenList]) {
            adaptToChildrenList(c);
          }
        }
      }

      return tree;
    },
  }
}
</script>
<style scoped>
.titleName {
  height: 55px;
}

.spot {
  color: #008D40;
  padding: 0 5px;
  width: 20px;
  height: 20px;
  border-radius: 50px;
}

.newtitle:hover {
  color: #008D40;
}

.widthbox {
  height: 520px;
}

.newcontent {
  color: #989898;
  font-size: 14px;
  padding: 15px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.newtitle {
  font-weight: 600;
  cursor: pointer;
}

.flexbox {
  padding: 40px 0;
  margin: auto;
  display: flex;
  justify-content: space-between;
  margin-left: 190px;
}

.flexmIg {
  width: calc(100% / 3);
  text-align: center;
}

.flexImg img {
  width: 70%;
}

.newbox {
  padding: 19px 0;
}

.newtext {
  max-height: 420px;
  overflow: auto;
  padding: 0 55px;
}

.newDetail {
  float: left;
  /*width: calc(100% - 50%);*/
  padding: 15px;
}

.borbox {
  width: 30%;
  border-left: solid 1px #CACACA;
}

.titbox {
  padding: 0 15px;
  cursor: pointer;
}

.active {
  border: solid 1px #008D40;
  background: #008D40;
  color: #fff;
  border-radius: 2px;
  font-weight: 600;
}

.tabbox div {
  border: solid 1px #CACACA;
  padding: 10px 15px;
  cursor: pointer;
  font-weight: 600;
  width: 15% !important;
  margin-bottom: 15px;
  text-align: center !important;
}

.news {
  border-left: solid 1px #CACACA;
  padding: 15px;
  font-weight: 600;
  width: 30%;

}

.new div {
  color: #009444;
}

.newtit {
  border-left: solid 5px #008D40;
  height: 43px;
  padding: 0px 10px;
  font-size: 20px;
}

.tabbox {
  width: 100%;
  display: flex;
  padding: 15px 0;
  justify-content: space-between;
  max-height: 220px;

}

.flexsbox {
  display: flex;
}

.more {
  color: #06A0F6;
  float: right;
  font-size: 16px;
  cursor: pointer;
}

.textbox {
  text-indent: 2em;
  line-height: 2.2;
}

.cenbox {
  text-align: center;
  padding: 15px;
  font-weight: 600;
}

.jsbox {
  width: 100%;
  display: flex;
  background-image: url("../../static/img/homeQyzx1.png");
  background-size: 100% 100%;
  height: 1430px;
  margin: 15px 0;
}

.dszbox {
  display: flex;
  background-image: url("../../static/img/dszjiyu.jpg");
  background-size: 100% 100%;
  height: 800px;
}

.introduce {
  background: #FFFFFF;
  padding: 15px;
  height: 350px;
  margin-top: 40px;
  border-radius: 15px;
  margin-left: -200px;
  width: 700px;
  z-index: 2;
}

.imgbox {
  margin: 15px 0 0px 40px;
  width: 60%;
  height: 400px;
  /*z-index:1;*/
  /*position: absolute;*/
  background-image: url("../../static/img/img.jpg");
  background-size: 100% 100%;
}

.lowerbox {
  background-color: #F5F5F5;
  padding: 25px;
  margin: 15px;
  margin-left: 3%;
  width: 90%;
}

.mlbox {
  border-left: solid 5px #008D40;
  padding: 0px 10px;
  font-size: 20px;
  font-weight: 600;
}

.pctitle {
  font-size: 10px;
}

.cpb {
  padding: 15px 0;
  overflow: auto;
}


.cpbox1 {
  width: calc(100% / 6 - 30px);
  float: left;
  margin: 15px;
  cursor: pointer;
}

.cpsimg {
  text-align: center;
}

.cpimg {
  height: 220px;
  width: 200px;
  object-fit: cover;
}

.cpname {
  background-color: #F7F7F7;
  text-align: center;
}

.titleName {
  min-height: 45px;
  display: flex;
  justify-content: center;
  /* 水平居中 */
  align-items: center;
  /* 垂直居中 */
}

.detailbox {
  font-size: 14px;
  background-color: rgb(0, 140, 62);
  width: 110px;
  margin: 14px auto;
  border-radius: 5px;
  color: rgb(255, 255, 255);
  padding: 5px;
}

.xqbox {
  color: rgb(158, 159, 159);
  font-size: 12px;
}

@media screen and (max-width: 500px) {
  .cpbox1 {
    width: calc(100% / 2 - 30px);
    float: left;
    margin: 15px;
    cursor: pointer;
  }

  .newsbigbox {
    width: 100% !important;
  }

  .newsboxs {
    display: block;
  }

  .newbox2 {
    width: 100%;
    padding: 0px;
  }

  .widthbox {
    height: 100%;
  }

  .flexsbox {
    display: block !important;
    overflow: hidden !important;
  }

  .newtext {
    overflow: auto;
    max-height: 320px;
    padding: 15px;
  }

  .flexbox {
    margin-left: 0px;
    padding: 0;
    display: block;
    width: 90% !important;
    margin: auto;
  }

  .flexbox div {
    margin-bottom: 15px;
  }

  .flexImg img {
    width: 100% !important;
  }

  .phoneImg {
    display: block;
  }

  .tabbox {
    width: calc(100% - 5px);
    padding: 30px 0;
    justify-content: flex-start;
    margin-left: 0px;
  }

  .active {
    /*padding: 5px;*/
  }

  .tabbox div {
    padding: 3px 15px;
    cursor: pointer;
    font-weight: 600;
    width: 33% !important;
  }

  .introduce {
    background: #FFFFFF;
    padding: 15px;
    height: 350px;
    margin-top: -122px;
    border-radius: 15px;
    margin-left: 0px;
    width: 330px;
  }

  .imgbox {
    margin: 15px 0 90px 15px;
    width: 95%;
    height: 150px;
    border-radius: 15px;
    /*z-index:1;*/
    /*position: absolute;*/
    background-image: url("../../static/img/img.jpg");
    background-size: 100% 100%;
  }

  .jsbox {
    display: block;
    background-image: url("../../static/img/homeQyzx2.jpg");
  }

  .dszbox {
    width: 100%;
    background-image: url("../../static/img/homeDsz2.jpg");
  }
}
</style>
